import { render, staticRenderFns } from "./CreateIncidentHeader.vue?vue&type=template&id=65a1419f&"
import script from "./CreateIncidentHeader.vue?vue&type=script&lang=js&"
export * from "./CreateIncidentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports